import { AccessRightBit } from '../constants/access-right-bit';

export class AccessRight {
  static Read = AccessRightBit.Read;
  static Edit = AccessRightBit.Read | AccessRightBit.Edit;
  static Save = AccessRightBit.Read | AccessRightBit.Save;
  static Print = AccessRightBit.Read | AccessRightBit.Print;
  static AllRights =
    AccessRightBit.Read | AccessRightBit.Edit | AccessRightBit.Save | AccessRightBit.Print | AccessRightBit.AllRights;
  static NotWatermark = AccessRightBit.Read | AccessRightBit.NotWatermark; // AccessRightResponsibleBit.Read ?
  static NotRedacted = AccessRightBit.Read;
  static DocumentOwner = AccessRightBit.Read | AccessRightBit.DocumentOwner; // AccessRightResponsibleBit.Read ?
  static FullAccess = AccessRight.AllRights | AccessRightBit.NotWatermark;
  static RestrictVersions = AccessRightBit.RestrictVersions;
  static NoAccess = 0;
  static DirectAccessBits: AccessRightBit[] = [AccessRightBit.DocumentOwner, AccessRightBit.RestrictVersions];

  static containsBits(val: number, bits: number): boolean {
    return (val & bits) === bits;
  }

  static create(value?: number | number[]): AccessRight {
    let numberValue = 0;
    if (typeof value === 'number') {
      numberValue = value;
    } else if (value && value.length) {
      value.forEach((item) => (numberValue |= item));
    }
    return new AccessRight(numberValue);
  }

  get readable() {
    return this.hasAccess(AccessRightBit.Read);
  }
  set readable(value: boolean) {
    this.updateAccess(AccessRightBit.Read, AccessRight.Read, value);
  }

  get editable() {
    return this.hasAccess(AccessRightBit.Edit);
  }
  set editable(value: boolean) {
    this.updateAccess(AccessRightBit.Edit, AccessRight.Edit, value);
  }

  get savable() {
    return this.hasAccess(AccessRightBit.Save);
  }
  set savable(value: boolean) {
    this.updateAccess(AccessRightBit.Save, AccessRight.Save, value);
  }

  //get printable() { return this.hasAccess(AccessRightBit.Print); }
  //set printable(value: boolean) { this.updateAccess(AccessRightBit.Print, AccessRight.Print, value); }

  get noWatermark() {
    return this.hasAccess(AccessRightBit.NotWatermark);
  }
  set noWatermark(value: boolean) {
    this.updateAccess(AccessRightBit.NotWatermark, AccessRight.NotWatermark, value);
  }

  get documentOwner() {
    return this.hasAccess(AccessRightBit.DocumentOwner);
  }
  set documentOwner(value: boolean) {
    this.updateAccess(AccessRightBit.DocumentOwner, AccessRight.DocumentOwner, value);
  }

  get allRights() {
    return this.hasAccess(AccessRightBit.AllRights);
  }
  set allRights(value: boolean) {
    this.updateAccess(AccessRightBit.AllRights, AccessRight.AllRights, value);
  }

  get fullAccess() {
    return this.hasAccess(AccessRight.FullAccess);
  }
  set fullAccess(value: boolean) {
    this.updateAccess(AccessRightBit.AllRights, AccessRight.FullAccess, value);
  }

  get noAccess() {
    return this.value === 0;
  }

  get noVersionsAccess() {
    return this.hasAccess(AccessRight.RestrictVersions);
  }

  set noAccess(value: boolean) {
    this.value = 0;
  }

  constructor(private value: number) {}

  getValue(): number {
    return this.value;
  }

  private updateAccess(accessBit: number, accessValue: number, addAccess: boolean) {
    this.value = addAccess
      ? this.addAccessRight(this.value, accessValue)
      : this.removeAccessRight(this.value, accessBit);
  }

  private hasAccess(accessBit: number): boolean {
    if (AccessRight.DirectAccessBits.includes(accessBit)) {
      return AccessRight.containsBits(this.value, accessBit);
    } else {
      return (
        AccessRight.containsBits(this.value, accessBit) || AccessRight.containsBits(this.value, AccessRight.FullAccess)
      );
    }
  }

  private addAccessRight(currentValue: number, accessRightValue: number): number {
    return currentValue | accessRightValue;
  }

  private removeAccessRight(currentValue: number, accessRightBit: number): number {
    return currentValue & ~accessRightBit;
  }
}
